import 'react-datepicker/dist/react-datepicker.css';
import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import moment from "moment";

interface DatePickerProps {
    onChange: (value: any) => void;
    values: string;
    dayCounts?: Record<string, number>;
}

export const DateRangeSelect: React.FC<DatePickerProps> = ({ onChange, values, dayCounts }) => {
    const [startDate, setStartDate] = useState<Date | null>();
    const [endDate, setEndDate] = useState<Date | null>(null);
    const { auther } = useSelector((state: any) => state.auth);
    const isAllowedToSelectRedDates = auther?.priorityDueDateAccess;
    useEffect(() => {
        if (values && values.includes(" to ")) {
            const [startStr, endStr] = values.split(" to ");
            const start = moment(startStr).toDate();
            const end = moment(endStr).toDate();

            if (!isAllowedToSelectRedDates && dayCounts) {
                const isStartForbidden = dayCounts[startStr] >= 35;
                const isEndForbidden = dayCounts[endStr] >= 35;

                if (isStartForbidden || isEndForbidden) {
                    toast.error("Date is fully booked.");
                    setStartDate(null);
                    setEndDate(null);
                    onChange("");
                    return;
                }
            }

            setStartDate(start);
            setEndDate(end);
        } else {
            setStartDate(null);
            setEndDate(null);
        }
    }, [values, isAllowedToSelectRedDates, dayCounts]);

    const handleDateChange = (dates: [Date | null, Date | null] | null) => {
        if (Array.isArray(dates)) {
            const [start, end] = dates;

            if (!isAllowedToSelectRedDates && dayCounts) {
                if (start) {
                    const dateStr = moment(start).format("YYYY-MM-DD");
                    if (dayCounts[dateStr] >= 35) {
                        return;
                    }
                }
                if (end) {
                    const dateStr = moment(end).format("YYYY-MM-DD");
                    if (dayCounts[dateStr] >= 35) {
                        return;
                    }
                }
            }

            setStartDate(start);
            setEndDate(end);
            const formattedValue = start && end ? `${moment(start).format("YYYY-MM-DD")} to ${moment(end).format("YYYY-MM-DD")}` : '';
            onChange(formattedValue);
        }
    };

    const getDayClassName = (date: Date) => {
        if (!dayCounts) return "";
        const dateStr = moment(date).format("YYYY-MM-DD");
        const count = dayCounts[dateStr] || 0;
        const day = moment(date).day();
        const isWeekend = day === 0 || day === 6;

        if (isWeekend) return "";
        if (count >= 35) return "calendar-day-high";
        if (count >= 16 && count <= 34) return "calendar-day-medium";
        if (count >= 5 && count <= 15) return "calendar-day-low";
        return "";
    };

    return (
        <ReactDatePicker

            selected={startDate}
            onChange={handleDateChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
            isClearable
            maxDate={undefined}
            dayClassName={getDayClassName}
            filterDate={(date: Date) => {
                if (isAllowedToSelectRedDates) return true;
                if (!dayCounts) return true;
                const dateStr = moment(date).format("YYYY-MM-DD");
                const count = dayCounts[dateStr] || 0;
                return count < 35; // Block if count >= 35
            }}
        // showMonthDropdown
        // showYearDropdown
        // dropdownMode="select"
        />
    );
};
